import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MobileOtpComponent } from './mobile-otp/mobile-otp.component';
import { Error503Component } from './error503/error503.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CRSdeclarationComponent } from './crsdeclaration/crsdeclaration.component';
import { MobileVerificationComponent } from './mobile-verification/mobile-verification.component';
import { PAKnationalitydetailsComponent } from './PAK-nationality-details/PAK-nationality-details.component';
import { AuthGuardService as AuthGuard } from './Services/auth-guard.service';



const routes: Routes = [
  {
    path: '', redirectTo: '/MobileVerification', pathMatch: 'full'
  },
  {
    path: 'MobileVerification', component: MobileVerificationComponent
  },
  { path: 'MobileVerification/:id', component: MobileOtpComponent },

  {
    path: 'PAK-nationality-details', component: PAKnationalitydetailsComponent
  },
  {
    path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard]
  },

  {
    path: 'mobileOTP', component: MobileOtpComponent
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(mod => mod.RegisterModule)
  },
  {
    path: 'minor',
    loadChildren: () => import('./minor/minor.module').then(mod => mod.MinorModule)
  },
  {
    path: 'error503', component: Error503Component
  },
  {
    path: 'CRSdeclaration', component: CRSdeclarationComponent
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
